// Full-page authorization-denial screen for an authenticated Bekaert user who
// is NOT a chat_user / admin in ANY tenant (GET /v1/me/tenants → []). The
// backend already 403s every tenant-scoped chat route for such a user; this is
// the matching frontend gate so the chat shell is never shown to someone who
// cannot use it. Mirrors AuthScreen's layout/tokens for visual continuity.

import { BekaertWordmark } from "@/auth/AuthScreen";

export function NoAccessScreen({ onSignOut, accountName }: { onSignOut: () => void; accountName?: string }) {
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-8 bg-[var(--surface-canvas)] px-6 text-center text-[var(--text-primary)]">
      <BekaertWordmark />
      <div className="flex max-w-md flex-col items-center gap-3" role="alert">
        <h1 className="type-h2 text-[var(--text-primary)]">No workspace access</h1>
        <p className="type-body-lg text-[var(--text-secondary)]">
          Your account isn't a member of any Bekaert Knowledge workspace yet. Ask your administrator to grant you
          access, then sign in again.
        </p>
        {accountName ? (
          <p className="type-body-sm text-[var(--text-tertiary)]">
            Signed in as <span className="font-medium text-[var(--text-secondary)]">{accountName}</span>
          </p>
        ) : null}
        <button
          type="button"
          onClick={onSignOut}
          className="type-cta mt-2 rounded-[var(--radius-pill)] bg-[var(--accent-primary)] px-6 py-2.5 text-[var(--text-on-accent)] transition-colors duration-[var(--dur-fast)] hover:bg-[var(--accent-hover)] focus-visible:outline-none focus-visible:shadow-[var(--elev-focus)]"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
